import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { IPermissionProps } from "../../models/Login";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { IModal } from "./Process";
import { Dialog } from "primereact/dialog";
import DOMPurify from 'dompurify';
import { Accordion, AccordionTab } from "primereact/accordion";
import { EmptySkillFilter, Filter, ISkillFilter } from "./Filter";

export interface IProcess {
    process_ID?: number,
    company_Name?: string | null,
    process_Name?: string | null,
    department?: string | null,
    subDepartment?: string | null,
    resPerson?: string | null,
    altResPerson?: string | null,
    action?: string | null,
    reaction?: string | null,
    definedBy?: number | null,
    createdOn?: Date | null,
    department_ID?: number | null
    subDepartment_ID?: number | null
    company_ID?: number | null
}

export const EmptyProcess: IProcess = {
    company_Name: "",
    process_Name: "",
    department: "",
    subDepartment: "",
    resPerson: "",
    altResPerson: "",
    action: null,
    reaction: null,
}

interface Iprops {
    setModal: (modal: IModal) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps,
    setReload: (is: boolean) => void,
}

export const Table = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IProcess>, loading: boolean });
    const [skillFilter, setSkillFilter] = useState<ISkillFilter>(EmptySkillFilter);

    const dt = useRef<any>(null);
    const [modal, setModal] = useState<IModal>({
        open: false,
        singleData: {} as IProcess,
        // readonly: false
    });
    const leftToolbarTemplate = () => {
        return (

            <div className="my-2">
                <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
            </div>

        );
    };

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyProcess });
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Process</h5>
        </div>
    );

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("tbl_process", "GET", null, `filter=${JSON.stringify(skillFilter)}`, props.toast);
        if (response) {
            const data: Array<IProcess> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    useEffect(() => {
        loadTableData();
    }, [props.reload, skillFilter]);

    const openEdit = (rowData: IProcess) => {
        props.setModal({ open: true, singleData: rowData });
    };

    const action = (rowData: IProcess) => {
        return (
            <div className="flex gap-3">
                <Button className="pi pi-pencil text-primary bg-white border-none" onClick={() => openEdit(rowData)}></Button>
            </div>
        );
    }





    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter skillFilter={skillFilter} setSkillFilter={(skillFilter: ISkillFilter) => setSkillFilter(skillFilter)} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="75vh"
                resizableColumns showGridlines columnResizeMode="expand"
                value={tableData.tableData}
                emptyMessage="No Requirements found."
                header={header}
                loading={tableData.loading}
            >
                <Column field="process_ID" header="Process ID" style={{ maxWidth: '6rem' }} />
                <Column field="company_Name" header="Company Name" style={{ maxWidth: '17rem' }} />
                <Column header="Process" body={(rowData: IProcess) => (
                    <span
                        className="text-blue-600 cursor-pointer hover:underline"
                        onClick={() => {
                            setModal({ open: true, singleData: rowData });
                        }}
                    >
                        {rowData.process_Name}
                    </span>
                )} />
                <Column field="department" header="Department" style={{ maxWidth: '15rem' }} />
                <Column field="subDepartment" header="Sub Department" />
                <Column field="" header="Action" body={action} />

            </DataTable>
            <Dialog
                header={modal.singleData.process_Name}
                visible={modal.open}
                style={{ width: '60vw' }}
                onHide={() => setModal({ open: false, singleData: {} as IProcess })}
                modal
            >

                <>
                    <div className="mb-3">
                        <h6>Action:</h6>
                        <div
                            className="p-3 border rounded"
                            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(modal.singleData.action || "") }}
                        />
                    </div>
                    <div className="mb-3">
                        <h6>Reaction:</h6>
                        <div
                            className="p-3 border rounded"
                            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(modal.singleData.reaction || "") }}
                        />
                    </div>
                </>

            </Dialog>

        </>
    );
}